import {
  addBreadcrumb,
  captureException,
  captureMessage,
  configureScope,
  Severity,
} from '@sentry/react';
import { DEV_ENV } from '../../constants/env';

const isDevelopment = DEV_ENV;
// const isDevelopment = false;

export const UserActionSeverity = Severity;

export function trackUserAction(
  message,
  category = 'ui.cta-click',
  severity = UserActionSeverity.Info,
) {
  if (isDevelopment) return;

  addBreadcrumb({
    category,
    type: 'user',
    message,
    level: severity,
  });
}

export function trackAppAction(message, severity = UserActionSeverity.Info) {
  if (isDevelopment) return;

  trackUserAction(message, 'ui.app-state', severity);
}

export function trackError(error) {
  if (isDevelopment) return;

  addBreadcrumb({
    category: 'error',
    type: 'error',
    level: Severity.Error,
    data: error,
  });
}

export function sentryCaptureMessage(
  message,
  severity = UserActionSeverity.Info,
) {
  if (isDevelopment) return;

  captureMessage(message, severity);
}

export function sentryCaptureError(errorTitle, context) {
  if (isDevelopment) return;

  captureMessage(errorTitle, {
    level: UserActionSeverity.Error,
    ...context,
  });
}

export function sentryCaptureException(exception, captureContext) {
  if (isDevelopment) return;

  captureException(exception, captureContext);
}

export function setupSentryScope({ id }) {
  if (isDevelopment) return;

  configureScope(scope => {
    scope.clear();
    scope.setUser({ id });
  });
}



// WEBPACK FOOTER //
// ./src/utils/sentry/sentryMethods.js